import { useState, useContext, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
  Text,
  Button,
  useToast,
  Icon,
} from '@chakra-ui/react';
import { CustomBinIcon } from '../../theme/multicolor-icons/CustomBinIcon';
import { HttpContext } from '../../context/HttpContext';
import CustomToast from '../../common/CustomToast';

const DeleteWebhookModal = ({
  isOpen,
  onClose,
  fetchData,
  webhookSubscriptionId,
}) => {
  const { authAxios } = useContext(HttpContext);
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteWebhook = async () => {
    setIsDeleting(true);
    try {
      await authAxios.delete(
        `/api/v1/webhook-subscriptions/${webhookSubscriptionId}`
      );
      toast({
        render: ({ onClose }) => (
          <CustomToast
            status="success"
            title="Webhook subscription deleted"
            onClose={onClose}
          />
        ),
      });
      fetchData?.({ pageIndex: 0, pageSize: 5 });
      onClose();
    } catch (err) {
      toast({
        render: ({ onClose: toastClose }) => (
          <CustomToast
            status="error"
            title="Something went wrong"
            description="Please try again later."
            onClose={toastClose}
          />
        ),
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody pt={10}>
          <VStack spacing={6} py={4} textAlign="center">
            <Icon as={CustomBinIcon} boxSize="40px" />
            <Text fontSize="lg" fontWeight="semibold">
              Are you sure you want to delete this webhook subscription?
            </Text>
            <Text fontSize="sm" color="gray.500">
              This action can’t be undone.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter justifyContent="flex-end" gap={4}>
          <Button
            variant="link"
            color="primaryDark"
            onClick={onClose}
            size="sm"
          >
            Cancel
          </Button>

          <Button onClick={deleteWebhook} isLoading={isDeleting} size="sm">
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteWebhookModal;
